
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { fadeIn } from '../variants';
import './styles/projectFilters.css';
import ProjectModal from './ProjectModal';
import projectImage01 from '../img/projectImage01.png';
import projectImage02 from '../img/projectImage02.png';
import projectImage03 from '../img/projectImage03.png';
import projectImage04 from '../img/projectImage04.png'; // Image Ng-Pokemon
import angularLogo from '../img/Angular_full_color_logo.svg.png'; // Logo Angular
import projectImageReact from '../img/React-icon.svg.png';
import projectImage05 from '../img/Wordpress_Blue_logo.png';
import projectImage06 from '../img/xdlogo-icon.png';
import movieFrenzyLogo from '../img/newColorLogoMovieFrenzy_01_transparent_contour.png';
import PokedexLogo from './PokedexLogo';

const Project = () => {

    const [isMobile, setIsMobile] = useState(false);
    const [activeFilter, setActiveFilter] = useState('tous');
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Données des projets
    const projects = [
        {
            id: 1,
            title: 'MovieFrenzy',
            category: 'fullstack',
            description: 'Développement Full-Stack',
            fullDescription: 'MovieFrenzy est une application web moderne de streaming et découverte de films, utilisant l\'API TMDB pour offrir une expérience cinématographique complète. Le projet intègre des animations 3D avec Three.js, une internationalisation complète, et un système de gestion d\'utilisateurs avec Firebase.',
            image: projectImage01,
            images: [projectImage01], // Ajoutez plus d'images si vous en avez
            icon: projectImageReact,
            icons: [projectImageReact, movieFrenzyLogo], // React + MovieFrenzy logos
            link: 'https://moviefrenzy.ca/',
            github: null, // Ajoutez le lien GitHub si disponible
                technologies: [
                    'React 18',
                    'Firebase',
                    'Three.js',
                    'i18next',
                    'Axios',
                    'React Router',
                    'Lottie',
                    'TSParticles',
                    'Bootstrap',
                    'Sass',
                    'API TMDB'
                ],
            features: [
                'Recherche de films en temps réel via API TMDB',
                'Système d\'authentification avec Firebase',
                'Base de données Firestore pour les favoris',
                'Animations 3D interactives avec Three.js',
                'Interface multilingue (FR/EN) avec i18next',
                'Effets de particules immersifs',
                'Design responsive avec Bootstrap',
                'Animations Lottie pour l\'engagement'
            ],
            challenges: [
                'Intégration complexe de l\'API TMDB avec gestion du rate limiting',
                'Optimisation des performances avec Three.js pour mobile',
                'Mise en place d\'un système de cache pour réduire les appels API',
                'Gestion de l\'état global avec Context API',
                'Déploiement et configuration Firebase'
            ],
            role: 'Développeur Full-Stack - Conception complète de l\'architecture, design UI/UX, intégration API, animations 3D, et déploiement.',
            duration: '3 mois (2024)',
            techDetails: 'Architecture React moderne avec hooks, Context API pour la gestion d\'état, Firebase pour l\'authentification et la persistance des données, Three.js pour les éléments 3D interactifs.',
            featured: true
        },
        {
            id: 2,
            title: 'Ng-Pokemon',
            category: 'fullstack',
            description: 'Application Angular - Pokédex',
            fullDescription: 'Ng-Pokemon est une application web développée avec Angular qui permet d\'explorer l\'univers des Pokémon. Cette application interactive offre une interface moderne pour consulter les caractéristiques détaillées de chaque Pokémon, avec un système d\'authentification sécurisé et une architecture modulaire.',
            image: projectImage04,
            images: [projectImage04],
            icon: angularLogo,
            icons: [angularLogo], // Angular logo seulement
            customLogo: 'pokedex', // Logo Pokédex personnalisé
            link: 'https://pokedex.moviefrenzy.ca/login',
            github: null,
            technologies: [
                'Angular',
                'TypeScript',
                'RxJS',
                'Angular Material',
                'Bootstrap',
                'API REST',
                'JSON Server',
                'Angular Router',
                'Guards',
                'Services',
                'Observables',
                'Forms'
            ],
            features: [
                'Système d\'authentification avec guards Angular',
                'Liste complète des Pokémon avec pagination',
                'Recherche et filtrage en temps réel',
                'Fiches détaillées pour chaque Pokémon',
                'Système de types avec couleurs distinctives',
                'Interface responsive avec Angular Material',
                'Gestion des états avec RxJS',
                'Mode combat entre Pokémon',
                'Favoris et équipe personnalisée'
            ],
            challenges: [
                'Mise en place d\'une architecture Angular scalable',
                'Optimisation des performances avec lazy loading',
                'Gestion complexe des observables RxJS',
                'Implémentation de guards pour la sécurité',
                'Design d\'une interface intuitive pour mobile'
            ],
            role: 'Développeur Angular - Architecture complète, développement des composants, services, et intégration API.',
            duration: '2 mois (2024)',
            techDetails: 'Application Angular moderne avec TypeScript, utilisant RxJS pour la gestion réactive des données, Angular Material pour l\'UI, et une architecture modulaire avec lazy loading pour optimiser les performances.',
            featured: true
        },
        {
            id: 3,
            title: 'Site Wordpress',
            category: 'frontend',
            description: 'Développement Front-End',
            fullDescription: 'Site web professionnel développé avec WordPress pour un courtier immobilier, avec design personnalisé et optimisation SEO.',
            image: projectImage02,
            images: [projectImage02],
            icon: projectImage05,
            link: null, // Plus hébergé
            archived: true,
            archivedDate: '2023',
            technologies: ['WordPress', 'PHP', 'CSS', 'JavaScript', 'MySQL'],
            features: [
                'Thème WordPress personnalisé',
                'Formulaires de contact dynamiques',
                'Galerie de propriétés',
                'Optimisation SEO',
                'Design responsive'
            ],
            challenges: [
                'Personnalisation avancée du thème',
                'Optimisation des performances',
                'Intégration de plugins personnalisés'
            ],
            role: 'Développeur WordPress - Création du thème, personnalisation, et déploiement.',
            duration: '2 mois (2023)'
        },
        {
            id: 4,
            title: 'Maquette Prototype',
            category: 'mobile',
            description: 'Développement Mobile',
            fullDescription: 'Prototype d\'application mobile conçu avec Adobe XD, démontrant les principes modernes d\'UI/UX pour une expérience utilisateur optimale.',
            image: projectImage03,
            images: [projectImage03],
            icon: projectImage06,
            link: null, // Lien Adobe XD expiré
            archived: true,
            archivedDate: '2023',
            technologies: ['Adobe XD', 'UI/UX Design', 'Prototyping', 'Wireframing'],
            features: [
                'Design system complet',
                'Prototypes interactifs',
                'Animations de transition',
                'Guide de style unifié',
                'Tests utilisateurs'
            ],
            challenges: [
                'Création d\'une expérience utilisateur intuitive',
                'Cohérence visuelle sur toutes les écrans',
                'Optimisation du parcours utilisateur'
            ],
            role: 'UI/UX Designer - Conception complète de l\'interface et des interactions.',
            duration: '1 mois (2023)'
        }
    ];

    // Filtres disponibles
    const filters = [
        { id: 'tous', label: 'Tous', count: projects.length },
        { id: 'fullstack', label: 'Full-Stack', count: projects.filter(p => p.category === 'fullstack').length },
        { id: 'frontend', label: 'Front-End', count: projects.filter(p => p.category === 'frontend').length },
        { id: 'mobile', label: 'Mobile', count: projects.filter(p => p.category === 'mobile').length }
    ];

    // Filtrer les projets
    const filteredProjects = activeFilter === 'tous' 
        ? projects 
        : projects.filter(project => project.category === activeFilter);

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth <= 500);
        };

        // Vérifier immédiatement et ensuite à chaque redimensionnement
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);

        // Nettoyage de l'écouteur d'événements
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    // Utilisez une div normale au lieu de motion.div si isMobile est true
    const ResponsiveDiv = isMobile ? 'div' : motion.div;

    // Fonctions pour le modal
    const openModal = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setTimeout(() => setSelectedProject(null), 300); // Reset après l'animation
    };


    return (
        <section className="section min-h-screen lg:min-h-[85vh] py-56 sm:py-72 my-28 sm:my-44 mb-40 sm:mb-60" id='project'>
            <div className='container mx-auto px-4 lg:px-0'>
                {/* En-tête avec titre et filtres */}
                <div className='text-center mb-10' style={{ marginBottom: isMobile ? '1rem' : '0' }}>
                    <motion.h2 
                        variants={fadeIn("down", 0.2)}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.7 }}
                        className='h2 leading-tight mb-8'
                    >
                        Mes dernières <span style={{color: '#F5981D'}}>réalisations</span>
                    </motion.h2>
                    
                    {/* Boutons de filtre */}
                    <motion.div 
                        variants={fadeIn("up", 0.3)}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.7 }}
                        className='flex flex-wrap justify-center gap-4 mb-8'
                    >
                        {filters.map((filter) => (
                            <button
                                key={filter.id}
                                onClick={() => setActiveFilter(filter.id)}
                                className={`
                                    filter-button px-6 py-2 rounded-full font-semibold transition-all duration-300
                                    ${activeFilter === filter.id 
                                        ? 'active bg-gradient-to-r from-[#F5981D] to-[#F7761F] text-white shadow-lg shadow-orange-500/30' 
                                        : 'bg-transparent text-[#F5981D] border-2 border-[#875410] hover:border-[#F5981D] hover:shadow-md hover:shadow-orange-500/20'
                                    }
                                `}
                                style={{
                                    transform: activeFilter === filter.id ? 'scale(1.05)' : 'scale(1)',
                                }}
                            >
                                {filter.label}
                                <span className='ml-2 text-sm opacity-70'>({filter.count})</span>
                            </button>
                        ))}
                    </motion.div>
                </div>

                {/* Grille de projets */}
                <motion.div 
                    layout
                    className='projects-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-5'
                >
                    <AnimatePresence mode="wait">
                        {filteredProjects.map((project, index) => (
                            <motion.div
                                key={project.id}
                                layout
                                initial={{ opacity: 0, scale: 0.8, y: 20 }}
                                animate={{ opacity: 1, scale: 1, y: 0 }}
                                exit={{ opacity: 0, scale: 0.8, y: 20 }}
                                transition={{ 
                                    duration: 0.5, 
                                    delay: index * 0.1,
                                    ease: "easeOut"
                                }}
                                whileHover={{ y: -10 }}
                                className={`project-card group relative overflow-hidden border-2 border-white/50 rounded-xl projetVisual ${project.featured ? 'lg:col-span-2 lg:row-span-2' : ''}`}
                                onClick={() => openModal(project)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="project-card-content">
                                    <div className={`groupe-hover ${project.id === 2 ? 'bg-black/3.5' : 'bg-black/70'} z-40 w-full h-full absolute transition-all duration-300 cursor-pointer`}></div>
                                    
                                    {/* Indicateur de catégorie */}
                                    <div className='category-indicator'>
                                        {project.category === 'fullstack' && 'Full-Stack'}
                                        {project.category === 'frontend' && 'Front-End'}
                                        {project.category === 'mobile' && 'Mobile'}
                                    </div>
                                    
                                    <img 
                                        src={project.image} 
                                        alt={project.title}
                                        className='w-full h-full object-cover group-hover:scale-125 transition-all duration-500 cursor-pointer' 
                                    />

                                    {/* Technologies badges */}
                                    <div className='absolute top-4 right-4 flex flex-wrap gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50'>
                                        {project.technologies.map((tech, i) => (
                                            <span 
                                                key={i}
                                                className='tech-badge px-3 py-1 text-xs font-semibold rounded-full'
                                                style={{
                                                    background: 'rgba(245, 152, 29, 0.9)',
                                                    color: '#FFF',
                                                    backdropFilter: 'blur(4px)'
                                                }}
                                            >
                                                {tech}
                                            </span>
                                        ))}
                                    </div>

                                    <div className='absolute -bottom-full left-8 right-8 group-hover:bottom-20 transition-all duration-500 z-30' 
                                         style={{ color: '#F08927' }}>
                                        <span className='block px-4 py-2 rounded text-lg font-semibold'
                                              style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}>
                                            {project.description}
                                        </span>
                                    </div>
                                    
                                    <div className='absolute -bottom-full left-8 right-8 group-hover:bottom-8 transition-all duration-500 z-50'
                                         style={{ color: '#F08927' }}>
                                        <div className='flex items-center justify-between px-3 py-1.5 rounded'
                                             style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}>
                                            <span className='font-primary text-white text-2xl'>
                                                {project.title}
                                            </span>
                                            <div className='flex gap-2 items-center mr-2'>
                                                {project.customLogo === 'pokedex' && (
                                                    <PokedexLogo size="small" />
                                                )}
                                                {project.icons ? 
                                                    project.icons.map((icon, i) => (
                                                        <img key={i} src={icon} alt='Logo' className='h-9 w-auto max-w-[100px] object-contain' />
                                                    ))
                                                    : project.icon && <img src={project.icon} alt='Logo' className='h-9 w-auto object-contain' />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </motion.div>

                {/* Message si aucun projet */}
                {filteredProjects.length === 0 && (
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className='text-center py-20'
                    >
                        <p className='text-2xl text-[#F5981D]'>Aucun projet dans cette catégorie pour le moment</p>
                    </motion.div>
                )}
            </div>

            {/* Modal de projet */}
            <ProjectModal 
                project={selectedProject}
                isOpen={isModalOpen}
                onClose={closeModal}
            />
        </section>
    );
};

export default Project;

